export var ExchangeStatus;
(function (ExchangeStatus) {
    ExchangeStatus["STARTED"] = "started";
    ExchangeStatus["IN_PROGRESS"] = "inProgress";
    ExchangeStatus["COMPLETE"] = "complete";
    ExchangeStatus["FAILED"] = "failed";
})(ExchangeStatus || (ExchangeStatus = {}));
Object.setPrototypeOf(ExchangeStatus, null);
export const DEFAULT_PREFILL_OPTIONS = [
    { label: 'Min', value: 10 },
    { label: 'Half', value: 50_000 },
    { label: 'All', value: 100_000 },
];
export const LOGS = Object.freeze({
    START_ACCOUNT_DISCOVERY_FAILED: 'Start Account Discovery Failed',
    RATE_ID_MISMATCH: `RateId mismatch`,
    GETTING_ACCOUNT_NAME: 'Getting Account Name',
    SIMULATING_TX: 'Simulating Tx',
    UPSERTING_ORDER: 'Upserting Order',
    FAILED_TO_UPSERT_ORDER: 'Failed to upsert order',
    CANCEL_ORDER: 'Cancel Order',
});
